export enum Brand {
  RCCL = 'RCI',
  CELEBRITY = 'CCI',
  AZAMARA = 'ACC',
}
